import {takeLatest} from 'redux-saga/effects';
import * as constants from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(constants.DELETE_INVOICE_CODE_FROM_TRANSACTION.REQUEST, saga.deleteInvoiceCodeTransaction);
    yield takeLatest(constants.DELETE_INVOICE_CODE_FROM_TRANSACTION.FAILED, saga.deleteInvoiceCodeTransactionFail);
}